import React from "react";

import { ValuedIcon } from '../ValuedIcon/index';
import { Dialog } from 'primereact/dialog';
import { Card } from 'primereact/card';
import { Button } from "primereact/button";
import { Tag } from 'primereact/tag';

import GAS from "../../GAS";

import "./styles.css";

const EscalaAvaliativaModal = ({ escalasAvaliativa, visible, onHide, onEscalaUpdated }) => {

    if (!escalasAvaliativa || !Array.isArray(escalasAvaliativa)) {
        return (
            <Dialog header="Escalas Avaliativas" visible={visible} style={{ width: '50vw' }} onHide={onHide}>
                <p>Carregando escalas avaliativas...</p>
            </Dialog>
        );
    }

    const setEscalaAvaliativaPadrao = (id) => {
        if (onEscalaUpdated) {
            onEscalaUpdated(id);
        }

        onHide();

        let gasObj = GAS.getInstance();

        gasObj.request('MCPAEscalaAvaliativa.instance.SERVICE.PUTatualizarEscalaAvaliativaPadrao', id)
            .then((RESPONSE) => {
                if (RESPONSE.response === true) {
                    console.log('Escala atualizada com sucesso no servidor');
                } else {
                    console.error('ERRO!', 'Não foi possível atualizar a escala avaliativa padrão no servidor.');
                    window.location.reload();
                }
            }).catch((e) => {
                console.log("Erro no catch da escala avaliativa")
                console.error('ERRO!', 'Não foi possível atualizar a escala avaliativa padrão.', e);
                window.location.reload();              
            });
    }

    const getEscalaDescriptions = (escalaAvaliativa) => {
        let valoresQualitativos = escalaAvaliativa.map(objeto => {
            const valor = objeto.valorQualitativo.toLowerCase();
            return valor.charAt(0).toUpperCase() + valor.slice(1);
        });
        let descricoes = valoresQualitativos.join(' - ');
        
        return descricoes;
    }

    return (
        <>
            <Dialog header="Escalas Avaliativas" visible={visible} style={{ width: '50vw' }} onHide={onHide}>
                {escalasAvaliativa.length > 0 ? (
                    escalasAvaliativa.map((modelo) => {
                        if (!modelo || !modelo.escalaAvaliativa || !Array.isArray(modelo.escalaAvaliativa)) {
                            return null;
                        }
                        
                        return (
                            <Card id="card-accordion-question" key={modelo.id} title={modelo.title} subTitle={getEscalaDescriptions(modelo.escalaAvaliativa)}>
                                <div style={{ display: 'block' }}>
                                    <div title="Níveis" style={{ display: 'flex', marginBottom: '30px' }}>
                                        <ValuedIcon icon='pi pi-sort-alt' value={modelo.escalaAvaliativa.length} />
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        {modelo.default ? 
                                            <Tag severity="success" value="ESCALA ATIVA" style={{ backgroundColor: '#4caf50' }}></Tag> : 
                                            <Tag severity="danger" value="ESCALA DESATIVADA"></Tag>
                                        }
                                        {!modelo.default && 
                                            <Button 
                                                id='button-card-success' 
                                                className='p-button-success' 
                                                label='ATIVAR' 
                                                onClick={() => setEscalaAvaliativaPadrao(modelo.id)}
                                                icon='pi pi-check' 
                                                style={{ padding: '0 5px', backgroundColor: '#4caf50' }} 
                                            />
                                        }
                                    </div>
                                </div>
                            </Card>
                        )
                    })
                ) : (
                    <p>Nenhuma escala avaliativa disponível.</p>
                )}
            </Dialog>
        </>
    )
}

export default EscalaAvaliativaModal;